export const getFormulaMeanCentered = (opsional, similarity) => {
  const isAdjustedCosine = similarity === "Adjusted Cosine"

  let label
  let labelMean

  if (isAdjustedCosine) {
    label = opsional === "user-based" ? "User" : "Item"
    labelMean = opsional === "user-based" ? "Item" : "User"
  } else {
    label = opsional === "user-based" ? "User" : "Item"
    labelMean = opsional === "user-based" ? "User" : "Item"
  }

  switch (opsional) {
    case "user-based":
      return {
        formula: `\\[ S_{${label}{(u,i)}} = r_{ui} -\\mu_{${labelMean}(${isAdjustedCosine ? 'i' : 'u'})}  \\ \\ \\  \\forall u \\in \\left\\{1...m\\right\\} \\]`,
        detail_formula: [
          `\\[ 
           \\begin{array}{ll}
          S_{${label}{(u,i)}} & : \\text{Mean-centered} \\ \\text{pada} \\ \\text{user u} \\ \\text{terhadap} \\ \\text{item i} \\\\
          r_{ui} & : \\text{Rating } \\text{user} \\ u \\text{ terhadap } \\text{item} \\ i \\\\
          \\mu_{${label}(${isAdjustedCosine ? 'i' : 'u'})} & : \\text{Mean rating} \\ \\text{pada} \\ \\text{user} \\ u
           \\end{array}\\]`,
        ],
      };
    case "item-based":
      return {
        formula: `\\[ S_{${label}{(u,i)}} = r_{ui} -\\mu_{${labelMean}(${isAdjustedCosine ? 'u' : 'i'})}  \\ \\ \\  \\forall i \\in \\left\\{1...m\\right\\}  \\]`,
        detail_formula: [
          `\\[ 
          \\begin{array}{ll}
          S_{${label}{(u,i)}} &  : \\text{Mean-centered} \\ \\text{pada} \\ \\text{item i} \\ \\text{terhadap} \\ \\text{user u} \\\\
          r_{ui} & : \\text{Rating} \\ \\text{user} \\ u \\text{ terhadap} \\ \\text{item} \\ i \\\\
         \\mu_{${label}(${isAdjustedCosine ? 'u' : 'i'})} &  : \\text{Mean rating} \\ \\text{pada} \\ \\text{item} \\ i  
          \\end{array}\\]`,
        ],
      };
    default:
      return;
  }
};

// detail mean centered

export const getDetailFormulaMeanCenterdIndex = (
  rowIndex,
  colIndex,
  opsional,
  similarity
) => {
  let label
  let labelMean

  if (similarity === "Adjusted Cosine") {
    label = opsional === "user-based" ? "User" : "Item"
    labelMean = opsional === "user-based" ? "Item" : "User"
  } else {
    label = opsional === "user-based" ? "User" : "Item"
    labelMean = opsional === "user-based" ? "User" : "Item"
  }

  const isAdjustedCosine =
    similarity === "Adjusted Cosine";

  const i = rowIndex + 1;
  const u = colIndex + 1;

  let symbolLine = "";
  let ratingLine = "";
  let meanLine = "";

  if (isAdjustedCosine) {
    symbolLine = `S_{${label}}{(${i}, ${u})} & : \\text{Mean-centered pada item } ${i} \\text{ terhadap user } ${u}`;
    ratingLine = `r_{${i}, ${u}} & : \\text{Rating item } ${i} \\text{ oleh user } ${u}`;
    meanLine = `\\mu_{${labelMean}(${isAdjustedCosine && opsional === "user-based" ? u : i})} & : \\text{Mean rating pada item } ${isAdjustedCosine && opsional === "user-based" ? u : i}`;
  } else if (opsional === "user-based") {
    symbolLine = `S_{${label}}{(${i}, ${u})} & : \\text{Mean-centered pada user } ${i} \\text{ terhadap item } ${u}`;
    ratingLine = `r_{${i}, ${u}} & : \\text{Rating user } ${i} \\text{ terhadap item } ${u}`;
    meanLine = `\\mu_{${labelMean}(${i})} & : \\text{Mean rating pada user } ${i}`;
  } else if (opsional === "item-based") {
    symbolLine = `S_{${label}}{(${i}, ${u})} & : \\text{Mean-centered pada item } ${i} \\text{ terhadap user } ${u}`;
    ratingLine = `r_{${i}, ${u}} & : \\text{Rating item } ${i} \\text{ oleh user } ${u}`;
    meanLine = `\\mu_{${labelMean}(${i})} & : \\text{Mean rating pada item } ${i}`;
  }

  return [
    `\\[
\\begin{array}{ll}
${symbolLine} \\\\
${ratingLine} \\\\
${meanLine}
\\end{array}
\\]`,
  ];
};

export const getFormulaMeanCenteredIndex = (
  rowIndex,
  colIndex,
  opsional,
  similarity
) => {

  let label
  let labelMean

  if (similarity === "Adjusted Cosine") {
    label = opsional === "user-based" ? "User" : "Item"
    labelMean = opsional === "user-based" ? "Item" : "User"
  } else {
    label = opsional === "user-based" ? "User" : "Item"
    labelMean = opsional === "user-based" ? "User" : "Item"
  }

  if (similarity === "Adjusted Cosine") {
    if (opsional === "user-based") {
      return `\\[S_{${label}{(${rowIndex + 1},${colIndex + 1})}} = 
      r_{{${rowIndex + 1}}, {${colIndex + 1}}} - \\mu_{${labelMean}(${colIndex + 1})}\\]`;
    } else if (opsional === "item-based") {
      return `\\[S_{${label}{(${rowIndex + 1},${colIndex + 1})}} = 
      r_{{${rowIndex + 1}}, {${colIndex + 1}}} - \\mu_{${labelMean}(${rowIndex + 1})}\\]`;
    }
  }

  switch (opsional) {
    case "user-based":
      return `\\[S_{${label}{ (${rowIndex + 1}, ${colIndex + 1}) }} = 
      r_{{${rowIndex + 1}}, {${colIndex + 1}}} - \\mu_{${labelMean}(${rowIndex + 1})}\\]`;

    case "item-based":
      return `\\[S_{${label}{(${rowIndex + 1}, ${colIndex + 1})}} = 
      r_{{${rowIndex + 1}}, {${colIndex + 1}}} - \\mu_{${labelMean}(${rowIndex + 1})}\\]`;

    default:
      return "";
  }
};

export const getFormulaMeanCenteredValue = (
  rowIndex,
  colIndex,
  dataOnly,
  result,
  opsional,
  selectedValue,
  similarity,
  isNotation
) => {

  const isAdjustedCosineUserBased =
    (similarity === "Adjusted Cosine" && opsional !== "user-based") ||
    ((similarity === "Cosine" ||
      similarity === "Pearson Correlation Coefficient" ||
      similarity === "Bhattacharyya Coefficient") &&
      opsional === "item-based");

  // Ambil mean list yang sesuai
  const meanList = result?.["mean-list"];

  // FIX: Ambil nilai rating dengan menukar indeks jika kasus khusus
  const selectedValueRating = dataOnly?.[rowIndex]?.[colIndex] // Indeks ditukar karena dataOnly adalah matriks transpose

  // FIX: Ambil nilai mean yang sesuai dengan logika baru
  const selectedMeanValue = (() => {
    if (rowIndex == null || colIndex == null || !meanList) return null;

    if (similarity === "Adjusted Cosine") {
      if (opsional === "user-based") {
        return meanList[colIndex];
      } else if (opsional === "item-based") {
        return meanList[rowIndex];
      }
    }

    return opsional === "item-based" ? meanList[colIndex] : meanList[rowIndex];
  })();

  // FIX: Siapkan variabel untuk label dan indeks formula secara dinamis
  const mainEntity = isAdjustedCosineUserBased
    ? "item"
    : opsional.split("-")[0];

  // Untuk Adjusted Cosine User-Based, row merepresentasikan item, col merepresentasikan user

  // FIX: entity untuk mean label harus sesuai dengan jenis mean yang digunakan
  const meanEntity = isAdjustedCosineUserBased
    ? "item"
    : opsional === "item-based"
      ? "item"
      : "user";

  // FIX: meanIndex harus sesuai dengan index yang digunakan untuk mengambil mean
  const meanIndex = isAdjustedCosineUserBased
    ? colIndex + 1
    : opsional === "item-based"
      ? colIndex + 1
      : rowIndex + 1;

  const indexLabel = `S_{${mainEntity}(${rowIndex + 1},${colIndex + 1})}`;

  const ratingLabel = `r_{${rowIndex + 1},${colIndex + 1}}`;
  const meanLabel = `\\mu_{${meanEntity}(${meanIndex})}`;

  const formulaString = `\\[ ${indexLabel} = ${ratingLabel} - ${meanLabel} \\]`;
  const resultStringWithValue = `\\[ ${indexLabel} = ${selectedValueRating?.toFixed(
    2
  )} - ${selectedMeanValue?.toFixed(2)} \\]`;

  return {
    formula: !isNotation ? resultStringWithValue : formulaString,
    result: `\\[ ${indexLabel} = ${selectedValue?.toFixed(2)} \\]`,
  };
};
